import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { DataGrid } from "@mui/x-data-grid";
import { ReactQueryDevtools } from "react-query/devtools";
import config from "../config";
import { getItemWithExpiry } from "../utils";
import Paper from "@mui/material/Paper";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { DateRangePicker } from "rsuite";

const FraudTransactions = () => {
  const [loading, setLoading] = useState(false);
  const [fraudTransactionsData, setFraudTransactionsData] = useState([]);
  const [type, setType] = useState("");
  const [searchClicked, setSearchClicked] = useState(false);
  var date = new Date();
  date.setDate(date.getDate());
  const [dateRange, setDateRange] = useState<[Date, Date]>([date, new Date()]);

  const handleDateSelect = (value: any) => {
    setDateRange(value);
  };

  const fraudTransactionsColumns = [
    {
      field: "orderId",
      headerName: "Order ID",
      flex: 1,
    },
  ];

  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 10,
    page: 0,
  });

  const fetchFraudTransactions = async () => {
    try {
      setLoading(true);

      const user = getItemWithExpiry("user");
      if (!user || !user.token) {
        toast.error("You have no access");
        setLoading(false);
        return;
      }

      const formatDate = (date: Date): string =>
        date.toISOString().split("T")[0];
      const startDateFetch = dateRange[0];
      const startDate = formatDate(startDateFetch);
      const endDateFetch = dateRange[1];
      const endDate = formatDate(endDateFetch);

      let dateQuery = `&startDate=${encodeURIComponent(
        startDate
      )}&endDate=${encodeURIComponent(endDate)}`;
      let typeQuery = `&type=${type}`;

      const response = await axios.get(
        `${config.REST_ENDPOINT}/transactions/validate?key=${config.MAINTENANCE_BYPASS_KEY}${dateQuery}${typeQuery}`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      const responseData = response?.data.suspiciousOrders || [];
      setFraudTransactionsData(responseData);
      setLoading(false);
    } catch (error: any) {
      toast(
        error?.response?.data?.message
          ? error?.response?.data?.message
          : error?.message,
        {
          type: "error",
        }
      );
      setLoading(false);
    }
  };

  const getRowId = (row: any) => row.orderId;

  const handleSearchClick = () => {
    setSearchClicked(true);
  };

  useEffect(() => {
    if (searchClicked) {
      fetchFraudTransactions();
      setSearchClicked(false);
    }
    // eslint-disable-next-line
  }, [searchClicked]);

  return (
    <div>
      <Typography
        variant="h4"
        style={{ marginLeft: "5px", marginTop: "10px", fontWeight: "bold" }}
      >
        Fraud Transactions
      </Typography>
      <Grid container spacing={2} marginBottom="20px" alignItems="center">
        <Grid item xs={12} sm={3} md={3}>
          <p
            style={{
              marginLeft: "5px",
              padding: "10px 5px 5px 0px",
              float: "left",
            }}
          >
            Enter Date Range:
          </p>
          <DateRangePicker
            value={dateRange}
            onChange={handleDateSelect}
            style={{
              margin: "5px 0px 0px 0px",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="select-type-label">Select Type</InputLabel>
            <Select
              labelId="select-type-label"
              id="select-type"
              value={type}
              onChange={(e) => setType(e.target.value as string)}
              label="Select Type"
            >
              <MenuItem value="deposit">Deposit</MenuItem>
              <MenuItem value="withdrawal">Withdrawal</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Button
            style={{ marginTop: "5px" }}
            variant="contained"
            color="primary"
            onClick={handleSearchClick}
          >
            Verify
          </Button>
        </Grid>
      </Grid>
      <Paper elevation={3} style={{ marginTop: "-2px", padding: "20px" }}>
        <DataGrid
          columns={fraudTransactionsColumns}
          rows={fraudTransactionsData}
          loading={loading}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[10, 25, 50, 100]}
          autoHeight
          getRowId={getRowId}
        />
      </Paper>
      <ReactQueryDevtools />
    </div>
  );
};

export default FraudTransactions;
